import React from 'react'

const Message = () => {
  return (
    <div>
      <section class="container pb-5">
        <h1 class=" py-5 fw-bolder text-center mt-5">Car <span class="client-color">Reviews</span></h1>
        <div class="row row-cols-1 row-cols-lg-2 g-4">
          <div class="col">
            <div class="card h-100">
              <div class="row align-items-center ps-0 ps-lg-3">
                <div class="col-lg-6 text-center py-3 ">
                  <iframe class="img-fluid " src="https://www.youtube.com/embed/_zU8hdWixoM" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <div class="col-lg-6">
                  <div class="card-body">
                    <h5 class="card-title fw-bold">BMW 7 Series 740Li M Sport 2021</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <div class="row align-items-center ps-0 ps-lg-3">
                <div class="col-lg-6 text-center py-3">
                  <iframe class="img-fluid" src="https://www.youtube.com/embed/1SaqSIvon_U" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <div class="col-lg-6">
                  <div class="card-body">
                    <h5 class="card-title fw-bold">The Audi Car of the Future - Audi Skysphere
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <div class="row align-items-center ps-0 ps-lg-3">
                <div class="col-lg-6 text-center py-3">
                  <iframe class="img-fluid " src="https://www.youtube.com/embed/n9lCE6m55hw" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <div class="col-lg-6">
                  <div class="card-body">
                    <h5 class="card-title fw-bold">The Ultimate 7 Star Ultra Luxury Car | Preowned Mercedes S560 Maybach
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <div class="row align-items-center ps-0 ps-lg-3">
                <div class="col-lg-6 text-center py-3">
                  <iframe class="img-fluid" src="https://www.youtube.com/embed/a9HUgg9lGRo" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                </div>
                <div class="col-lg-6">
                  <div class="card-body">
                    <h5 class="card-title fw-bold">The New Rolls Royce Ghost!</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Message
